module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'loicq0b6',
    dataset: process.env.GATSBY_SANITY_DATASET || 'hans-new'
  }
}
